/**
 * @file web/src/config/social.ts
 * @description Single source of truth for Round Recon's public social profiles.
 *
 * Used by the footer (#218) for the "Follow" links and by the Organization
 * JSON-LD `sameAs` array (spec §16.4.2) so search engines associate the
 * profiles with the brand. Add/remove a profile here and both update.
 */

export interface SocialProfile {
  /** Accessible, human-readable platform name. */
  label: string;
  /** Canonical public profile URL. */
  href: string;
}

export const SOCIAL_PROFILES: readonly SocialProfile[] = [
  { label: 'Bluesky', href: 'https://bsky.app/profile/roundrecon.bsky.social' },
  { label: 'Threads', href: 'https://www.threads.com/@roundrecon' },
  { label: 'Mastodon', href: 'https://mastodon.social/@roundrecon' },
  { label: 'Instagram', href: 'https://www.instagram.com/roundrecon/' },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61590755911466' },
];

/** Just the URLs — for the Organization JSON-LD `sameAs` array. */
export const SOCIAL_URLS: readonly string[] = SOCIAL_PROFILES.map((p) => p.href);
